import {format, parseISO} from 'date-fns';
import {ptBR} from 'date-fns/locale';

export function formatManagementDecimal(value: number | null | undefined, fractionDigits = 2): string {
    if (value == null || Number.isNaN(value)) {
        return '-';
    }
    return value.toLocaleString('pt-BR', {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    });
}

export function formatManagementPercent(value: number | null | undefined): string {
    return formatManagementDecimal(value, 2);
}

export function formatManagementDisplayDate(value: string | null | undefined): string {
    if (!value) {
        return '-';
    }
    try {
        return format(parseISO(value.length === 10 ? value : value.slice(0, 10)), 'dd/MM/yyyy', { locale: ptBR });
    } catch {
        return value;
    }
}

export function formatManagementGeneratedOn(value: string): string {
    return formatManagementDisplayDate(value);
}

export function formatDailyCell(value: string): string {
    if (!value || value.trim() === '' || value === '-') {
        return '-';
    }
    return value;
}

export function formatWeekDayHeader(date: string, withinReferenceMonth: boolean): string {
    const label = formatManagementDisplayDate(date);
    return withinReferenceMonth ? label : `${label}*`;
}

export function formatReferencePeriodTitle(month: string, year: number): string {
    return `${month}/${year}`;
}

export function formatTechnicalField(value: string | number | null | undefined): string {
    if (value == null || value === '') {
        return 'Não informado';
    }
    return String(value);
}

export function formatMw(value: number): string {
    return `${formatManagementDecimal(value)} MW`;
}
